import type { VerticalDescriptor } from '../../core/vertical-engine/types';

import CalendarPageV2 from './pages/CalendarPageV2';
import InboxPage from './pages/InboxPage';
import WebEditorPage from './pages/WebEditorPage';
import BuilderV2Page from './web-builder-v2/BuilderV2Page';

export const peluqueriaVertical: VerticalDescriptor = {
  id: 'peluqueria',
  name: 'GlowPro',
  version: '2.0.0',
  routes: [
    { path: '/peluqueria/calendar', element: <CalendarPageV2 />, wrapInLayout: false },
    { path: '/peluqueria/inbox', element: <InboxPage />, wrapInLayout: true },
    { path: '/peluqueria/web-editor', element: <WebEditorPage />, wrapInLayout: true },
    { path: '/peluqueria/web-builder-v2', element: <BuilderV2Page />, wrapInLayout: false },
  ],
  menu: [
    { key: 'peluqueria:calendar', to: '/peluqueria/calendar', label: 'Calendario', icon: 'Calendar' },
    { key: 'peluqueria:inbox', to: '/peluqueria/inbox', label: 'Buzón', icon: 'Inbox' },
    { key: 'peluqueria:web-editor', to: '/peluqueria/web-editor', label: 'Web (V1)', icon: 'Globe' },
    { key: 'peluqueria:web-builder-v2', to: '/peluqueria/web-builder-v2', label: 'Builder V2', icon: 'Layout' },
  ],
};
